// Localização: frontend/src/hooks/useMedicamentos.js (0.2.3)

import { useState, useCallback } from 'react'; // Remove useEffect
import { get, post, put, remove } from '../api/api';
import { useAuth } from '../context/AuthContext'; 

/**
 * Hook para gerenciamento de dados de Medicamentos base (cadastro).
 * Lotes e Alertas foram movidos para useLotes.js.
 * @returns {object} Estado e funções para interagir com a API de Medicamentos.
 */
export const useMedicamentos = () => {
    const { isAuthenticated } = useAuth();
    
    // 🛑 REMOVIDO: lotes, alertas, isLoadingLotes, isLoadingAlertas.
    // O useLotes cuidará desses estados.
    const [medicamentos, setMedicamentos] = useState([]);
    
    // Estados de carregamento
    const [isLoadingMedicamentos, setIsLoadingMedicamentos] = useState(false);
    const [error, setError] = useState(null);
    
    // Gatilho para forçar re-fetch (MANTIDO para ser exposto ao componente)
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const refreshData = () => {
        setRefreshTrigger(prev => prev + 1); 
    };

    // -------------------------------------------------------------------
    // FUNÇÃO DE BUSCA (READ)
    // -------------------------------------------------------------------

    const fetchMedicamentos = useCallback(async () => {
        if (!isAuthenticated) return;
        setIsLoadingMedicamentos(true);
        setError(null);
        try {
            const response = await get('/medicamentos'); 
            setMedicamentos(response.data.data || []);
        } catch (err) {
            console.error("Erro ao buscar medicamentos:", err);
            setError(err.response?.data?.message || "Falha ao carregar medicamentos.");
            setMedicamentos([]);
        } finally {
            setIsLoadingMedicamentos(false);
        }
    }, [isAuthenticated]);

    // -------------------------------------------------------------------
    // FUNÇÕES DE MUTAÇÃO (CREATE, UPDATE, DELETE)
    // -------------------------------------------------------------------
    // (Mantidas, pois são para Medicamentos)

    const createMedicamento = async (data) => {
        try {
            const response = await post('/medicamentos', data);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao cadastrar medicamento.');
        }
    };
    
    const updateMedicamento = async (id, data) => {
        try {
            const response = await put(`/medicamentos/${id}`, data);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao atualizar medicamento.');
        }
    };
    
    const deleteMedicamento = async (id) => {
        try {
            await remove(`/medicamentos/${id}`);
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao excluir medicamento.');
        }
    };
    
    // 🛑 REMOVIDO: createLote. Agora está em useLotes.js.

    // -------------------------------------------------------------------
    // RETORNO PÚBLICO
    // -------------------------------------------------------------------

    return {
        medicamentos,
        isLoadingMedicamentos,
        error,
        
        // Funções CRUD
        createMedicamento,
        updateMedicamento,
        deleteMedicamento,
        
        // Funções de controle
        refreshData, 
        fetchMedicamentos, 
        
        // 🛑 REMOVIDO: fetchLotes, fetchAlertas, lotes, alertas
    };
};